import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Collapse } from "@material-ui/core";
import Divider from "@mui/material/Divider";
import BentoBox from "../BentoBox/BentoBox";

import Filters from "./Filters/Filters";
import FilterFooter from "./Filters/FilterFooter";
import DividerWithText, {
  TP_HEAD,
} from "../UI/DividerWithText/DividerWithText";
import ConfigContext from "../../context/ConfigContext";
import classes from "./FilterContainer.module.css";

// eslint-disable-next-line no-unused-vars
import { base as ldbase } from "../../utils/LDFFUtils";

const FilterContainer = (props) => {
  const { filterExpanded, data } = props;
  const { organismFilters, fileFilters, goldFilters } =
    useContext(ConfigContext);

  // const jdp1481vers = ldbase(ldClient, FF);

  const orgSectionLabel = "Dataset";
  return (
    <>
      <BentoBox hasFilters {...props} />
      <Collapse className={classes.filtersCollapse} in={filterExpanded}>
        {goldFilters ? (
          <>
            <DividerWithText position={TP_HEAD}>Environment</DividerWithText>
            <Filters
              {...props}
              label="Environment"
              filterConfig={goldFilters}
              data={data}
            />
          </>
        ) : null}

        {organismFilters ? (
          <>
            <DividerWithText position={TP_HEAD}>
              {orgSectionLabel}
            </DividerWithText>
            <Filters
              {...props}
              label="Genomes"
              filterConfig={organismFilters}
              data={data}
            />
          </>
        ) : null}
        {fileFilters ? (
          <>
            <DividerWithText position={TP_HEAD}>File Property</DividerWithText>
            <Filters
              {...props}
              label="Files"
              filterConfig={fileFilters}
              data={data}
            />
          </>
        ) : null}
        <Divider />
        <FilterFooter {...props} />
      </Collapse>
    </>
  );
};

export default FilterContainer;

FilterContainer.defaultProps = {
  filterExpanded: false,
  data: null,
  ldClient: null,
  relevantIndex: null,
};

FilterContainer.propTypes = {
  filterExpanded: PropTypes.bool,
  data: PropTypes.shape(),
  ldClient: PropTypes.shape(),
  relevantIndex: PropTypes.number,
};
